import type {Editor} from 'grapesjs';
import {useEditorUndoRedoState} from '@Hooks/useEditorUndoRedoState';
import type {EditorUndoRedoState} from '@Hooks/useEditorUndoRedoState';
import {canRedo, canUndo} from '@EmailMakerReact/lib/email-maker-canvas-library';

export function useEmailMakerUndoRedoState(editor: Editor | null): EditorUndoRedoState {
  return useEditorUndoRedoState(editor, canUndo, canRedo);
}
